import {
  SALARYLIST_ALL,
  SALARYLIST_GET,
  SALARYLIST_PUT,
  SALARYLIST_DEL,
  SALARYLIST_POST,
  SALARYLIST_RESET,
  SALARYLIST_LOADING,
  SALARYLIST_ERROR,
} from '../../actions/types';

const initialState = {
  salaryList: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SALARYLIST_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARYLIST_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARYLIST_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case SALARYLIST_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case SALARYLIST_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case SALARYLIST_RESET:
      return { salaryList: null, isLoading: true, isCompleted: true };
    case SALARYLIST_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case SALARYLIST_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case 'SALARYLIST_UPDATE_LOCAL':
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
